import React from "react"
import PropTypes from "prop-types"
import Navbar from "./Navbar"
import Footer from "./Footer"
import { GatsbySeo } from "gatsby-plugin-next-seo"
import { useMetadata } from "../data/useMetaData"
import { useSetting } from "../data/useSetting"

const Layout = ({ children }) => {
  const { title, description, siteUrl, siteName, language } = useMetadata()
  const {
    contentfulSetting: { ogImage },
  } = useSetting()

  return (
    <>
      <GatsbySeo
        title={title}
        description={description}
        canonical={siteUrl}
        language={language}
        openGraph={{
          url: siteUrl,
          title: title,
          description: description,
          images: [
            {
              url: `https:${ogImage.file.url}`,
              width: 1200,
              height: 630,
              alt: title,
            },
          ],
          site_name: siteName,
          type: "website",
          locale: "zh_tw",
        }}
      />
      <div className="flex flex-col h-screen">
        <Navbar />
        <main className="mt-16 grow">{children}</main>
        <Footer />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
